// extracted by mini-css-extract-plugin
export default {"\t":"styles_-__58yKk","toastr":"styles_toastr__Wzh6g","toastrCont":"styles_toastrCont__-sbS-","title":"styles_title__xYsEg"};